import React, { useEffect, useState } from "react";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import { Button, Col, Form, Row } from "antd";
import { AppDispatch } from "../../../../store/app";
import { useDispatch } from "react-redux";
import { doNewsletterSubscribe } from "../utils/FooterSlice";
import { Notification } from "../../../../config/Global";
import { assignErrorToInput } from "../../../../store/api";
import { useLocation, useParams } from "react-router-dom";
import { BASE_URL } from "../../../../config/Constant";
import { ContactRequest } from "../../../../config/validations/formRules";

interface MyComponent {
  news_section: {
    title: any;
    content: any;
  };
}
const FooterNewsUpdatesSection: React.FC<MyComponent> = ({ news_section }) => {
  const [form] = Form.useForm();
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);
  const dispatch: AppDispatch = useDispatch();
  const location = useLocation();
  const params = useParams();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  const handleSubmit = () => {
    setSubmitLoading(true);
    const emailData = form.getFieldValue("email");

    form
      .validateFields(["email"])
      .then(() => {
        const payload = `email=${emailData}&t=newsletter&current_url=${BASE_URL}${location.pathname}`;
        dispatch(doNewsletterSubscribe(payload))
          .then((res: any) => {
            console.log("data form", res?.data);

            res?.data?.STATUS.NOTIFICATION?.map((msg: string) =>
              Notification.success({
                message: msg,
              })
            );
            form.resetFields();
          })
          .catch((formError: any) => {
            console.log("api error", formError);

            assignErrorToInput(form, formError?.STATUS?.error);

            formError?.STATUS?.NOTIFICATION?.map((msg: string) =>
              Notification.error({
                message: msg,
              })
            );
          })
          .finally(() => {
            setSubmitLoading(false);
          });
      })
      .catch((error: any) => {
        assignErrorToInput(form, error?.errorFields);
        setSubmitLoading(false);
      });
  };

  return (
    <div className="subscribeFormSection">
      <Row gutter={40} align={"middle"}>
        <Col xs={24} lg={12}>
          <h2 className="footerTitle">{news_section?.title}</h2>
          {/* <p className="summary">{news_section?.content}</p> */}
        </Col>
        <Col xs={24} lg={12}>
          <FormBox form={form} onFinish={handleSubmit}>
            <div className="subscribeForm">
              <InputBox.Text
                required
                name="email"
                placeholder="Your Email"
                disabled={submitLoading}
                maxLength={100}
                rules={ContactRequest().email("Your Email")}
              />
              <Button
                type="primary"
                htmlType="submit"
                loading={submitLoading}
                disabled={submitLoading}
              >
                Subscribe
              </Button>
            </div>
          </FormBox>
        </Col>
      </Row>
    </div>
  );
};

export default FooterNewsUpdatesSection;
